import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'catalogos/tipo-de-percepcion-de-nomina';

/**
 * GET Tipos de percepción de nóminas
 * @returns {Promise<object[]>}
 */
export const getTiposPercepcionesNominas = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
    /* eslint-disable-next-line no-unreachable */
  } catch (err) {
    onError(err);
  }
  return [];
};
